import React from 'react';
import { NavLink } from 'react-router-dom';

export function AdminNav() {
  const baseClass =
    'inline-flex items-center justify-center rounded-3xl border border-border px-6 py-4 text-base md:text-lg font-semibold font-display transition-colors hover:bg-secondary min-w-[170px]';
  const inactiveClass = 'bg-card text-foreground';
  const activeClass =
    'bg-[#0F3D2C] text-[#F1E6D3] border-transparent hover:bg-[#F5E6B3] hover:text-[#0F3D2C]';

  return (
    <div className="flex flex-wrap gap-4 justify-start">
      <NavLink
        to="/admin/termekek"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Termékek
      </NavLink>
      <NavLink
        to="/admin/beszerzes"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Beszerzés
      </NavLink>
      <NavLink
        to="/admin/rendelesek"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Rendelések
      </NavLink>
      <NavLink
        to="/admin/penzugy"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Pénzügy
      </NavLink>
      <NavLink
        to="/admin/projekt"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Projekt
      </NavLink>
    </div>
  );
}
